<template>
  <section class="registration__section bg__redish">

    <the-header
      :introDiscoveryTextProp="''"
      :introDiscoveryLinkProp="''"
    >
    </the-header>

    <section class="wrapper">

      <div class="registration__wrapper">
        <div class="registration__wrapper__headline" v-if="!loadQuestionSection">
          <h1
            @mouseover="MX_isZoom(true)"
            @mouseleave="MX_isZoom(false)"
          >
            The
            <br class="br--disabled">
            BurgundysCollection
            <br>
            Commitment
          </h1>
        </div>
        <div class="registration__wrapper__headline" v-else>
          <h1
            @mouseover="MX_isZoom(true)"
            @mouseleave="MX_isZoom(false)"
          >
            BurgundysCollection
            <br class="br--disabled">
            To know you better...
            <!-- <br>
            Commitment -->
          </h1>
        </div>

        <!-- MEMBER FORM -->
        <div
          class="registration__wrapper__form"
          :class="{'registration__wrapper__form--disabled': loadQuestionSection}"
        >
          <form autocomplete="off" @submit.prevent="onMemberFormSubmit" ref="memberForm">
            <!-- COMPNAY -->
            <!-- <div
              class="registration__wrapper__form__input text__right"
              @mouseover="MX_isZoom(true)"
              @mouseleave="MX_isZoom(false)"
            >
              <input
                type="text"
                name="member-company"
                placeholder="Company"
                v-model="inputCompany"
                :class="{
                  'input__field--white': inputCompanyError,
                  'input__field--full-width': focusCompany
                }"
                @blur.self="isCompanyFocused"
                @focus="focusCompanyField"
              >
            </div> -->
            <!-- ADDRESS -->
            <div
              class="registration__wrapper__form__input text__right"
            >
              <input
                type="text"
                name="member-address"
                placeholder="Address"
                v-model="inputAddress"
                :class="{
                  'input__field--white': inputAddressError,
                  'input__field--full-width': focusAddress
                }"
                @blur.self="isAddressFocused"
                @focus="focusAddressField"
                @mouseover="$store.commit('updateCursorType', 8)"
                @mouseleave="$store.commit('updateCursorType', 3)"
              >
            </div>
            <!-- COUNTRY -->
            <div
              class="registration__wrapper__form__input text__right"
            >
              <input
                type="text"
                name="member-country"
                placeholder="Country"
                v-model="inputCountry"
                :class="{
                  'input__field--white': inputCountryError,
                  'input__field--full-width': focusCountry
                }"
                @blur.self="isCountryFocused"
                @focus="focusCountryField"
                @mouseover="$store.commit('updateCursorType', 8)"
                @mouseleave="$store.commit('updateCursorType', 3)"
              >
            </div>
            <!-- EMAIL -->
            <div
              class="registration__wrapper__form__input text__right"
            >
              <input
                type="email"
                name="member-email"
                placeholder="Email"
                v-model="inputEmail"
                :class="{
                  'input__field--white': inputEmailError,
                  'input__field--full-width': focusEmail
                }"
                @blur.self="isEmailFocused"
                @focus="focusEmailField"
                @mouseover="$store.commit('updateCursorType', 8)"
                @mouseleave="$store.commit('updateCursorType', 3)"
              >
            </div>
            <!-- PHONE -->
            <div
              v-click-outside="isPhoneFocused"
              class="registration__wrapper__form__input text__right"
              @click="focusPhoneField"
            >
              <the-mask
                type="tel"
                name="member-phone"
                :mask="['+# #####-#####', '+## ######-####', '+## #######-####']"
                placeholder="Phone"
                v-model="inputPhone"
                :class="{
                  'input__field--white': inputPhoneError,
                  'input__field--full-width': focusPhone
                }"
                @blur.self.native="isPhoneFocused"
                @focus.native="focusPhoneField"
                @mouseover.native="$store.commit('updateCursorType', 8)"
                @mouseleave.native="$store.commit('updateCursorType', 3)"
              />
            </div>

            <!-- READ STATEMENT -->
            <p
              class="registration__wrapper__form__input"
            >
              I,
              <input
                type="text"
                name="firstAndLastName"
                placeholder="First name Last name"
                v-model="inputName"
                :class="{
                  'input__field--white': inputNameError
                }"
                @blur.self="isNameFocused"
                @focus="focusNameField"
                @mouseover="$store.commit('updateCursorType', 8)"
                @mouseleave="$store.commit('updateCursorType', 3)"
              >
               appreciate and acknowledge the values and ethics of BurgundysCollection and share the commitment to protect and respect the wine, the maker and the drinker. All BurgundysCollection allocations include complimentary, insured and unlimited storage in the heart of Burgundy and I understand that I would be buying wines for my personal enjoyment, not for re-selling.
            </p>

            <!-- SIGNATURE -->
            <div
              class="sign__wrapper"
            >
              <span>Sign: </span>
              <div class="sign__pad"
                @mouseover.stop="isOnSignature"
                @mouseleave.stop="isOffSignature"
              >
                <VueSignaturePad
                  width="100%"
                  height="185px"
                  ref="signaturePad"
                  :options="{
                    minWidth: 1,
                    maxWidth: 1.5,
                    minDistance: 1
                  }"
                />
              </div>
              <div class="sign__wrapper__buttons"
                @mouseover="MX_isZoom(true)"
                @mouseleave="MX_isZoom(false)"
              >
                <button type="button" @click="clearSignature">Clear</button>
                <button
                  type="submit"
                  @click="saveSignature"
                  class="submit__button"
                >Continue</button>
              </div>
            </div>

            <!-- ERROR MESSAGE -->
            <div
              class="error__message__wrapper text__right"
              :class="{'error__message__wrapper--active': showError}"
            >
              <span>Please enter your {{errorMessage}}</span>
            </div>
          </form>
        </div>

        <!-- QUESTIONS FORM -->
        <div
          class="questions__wrapper"
          :class="{'questions__wrapper--active': loadQuestionSection}"
        >
          <form ref="questionsForm">
            <!-- <p
              @mouseover="MX_isZoom(true)"
              @mouseleave="MX_isZoom(false)"
            >
              May we ask you two questions?
            </p> -->

            <div class="questions__wrapper__discovery">
              <label
                for="bc-discovery"
                :class="{'questions__label--active': isFocusedOnTxtDiscover||!isFocusedOnTxtDiscover}"
                @mouseover="MX_isZoom(true)"
                @mouseleave="MX_isZoom(false)"
              >
                How did you discover the wines of Burgundy?
              </label>
              <textarea-autosize
                name="burgundyDiscover"
                id="bc-discovery"
                ref="bcDiscover"
                rows="1"
                v-model="textareaTxtDiscover"
                :min-height="40"
                @focus.native="onFocusTextarea('bcDiscover')"
                @blur.native="onBlurTextarea('bcDiscover')"
                @mouseover.native="$store.commit('updateCursorType', 8)"
                @mouseleave.native="$store.commit('updateCursorType', 3)"
              ></textarea-autosize>
            </div>

            <div class="questions__wrapper__discovery">
              <label
                for="bc-domain"
                :class="{'questions__label--active': isFocusedOnTxtDomain||!isFocusedOnTxtDomain}"
                @mouseover="MX_isZoom(true)"
                @mouseleave="MX_isZoom(false)"
              >
                Why would you like a direct allocation from the Domains?
              </label>
              <textarea-autosize
                name="burgundyDomain"
                id="bc-domain"
                ref="bcDomain"
                rows="1"
                v-model="textareaTxtDomain"
                :min-height="40"
                @focus.native="onFocusTextarea('bcDomain')"
                @blur.native="onBlurTextarea('bcDomain')"
                @mouseover.native="$store.commit('updateCursorType', 8)"
                @mouseleave.native="$store.commit('updateCursorType', 3)"
              ></textarea-autosize>
            </div>

            <div class="questions__wrapper__discovery">
              <label
                for="bc-collection"
                :class="{'questions__label--active': isFocusedOnTxtDomain||!isFocusedOnTxtDomain}"
                @mouseover="MX_isZoom(true)"
                @mouseleave="MX_isZoom(false)"
              >
                How did you hear about BurgundysCollection?
              </label>
              <textarea-autosize
                name="burgundyCollection"
                id="bc-collection"
                ref="bcCollection"
                rows="1"
                v-model="textareaTxtCollection"
                :min-height="40"
                @focus.native="onFocusTextarea('bcCollection')"
                @blur.native="onBlurTextarea('bcCollection')"
                @mouseover.native="$store.commit('updateCursorType', 8)"
                @mouseleave.native="$store.commit('updateCursorType', 3)"
              ></textarea-autosize>
            </div>

            <div class="questions__wrapper__domain">
              <label
                for="bc-members"
                :class="{'questions__label--active': isFocusedOnTxtDomain||!isFocusedOnTxtDomain}"
                @mouseover="MX_isZoom(true)"
                @mouseleave="MX_isZoom(false)"
              >
                Do you know any BurgundysCollection members?
              </label>
              <textarea-autosize
                name="burgundyMembers"
                id="bc-members"
                ref="bcMembers"
                rows="1"
                v-model="textareaTxtMembers"
                :min-height="40"
                @focus.native="onFocusTextarea('bcMembers')"
                @blur.native="onBlurTextarea('bcMembers')"
                @mouseover.native="$store.commit('updateCursorType', 8)"
                @mouseleave.native="$store.commit('updateCursorType', 3)"
              ></textarea-autosize>
            </div>

            <div class="text__right">
              <button
                type="submit"
                @click="submitForm"
                class="submit__button"
                @mouseover="MX_isZoom(true)"
                @mouseleave="MX_isZoom(false)"
              >
                Continue
              </button>
            </div>
          </form>
        </div>
      </div>

    </section>

  </section>
</template>

<script>
import axios from 'axios'
import TheHeader from '@/components/TheHeader.vue'
import { TheMask } from 'vue-the-mask'
import { isZooming } from '../mixins/isZooming'

export default {
  name: 'Registration',
  components: {
    'the-header': TheHeader,
    'the-mask': TheMask
  },
  mixins: [
    isZooming
  ],
  data () {
    return {
      // Company
      // inputCompany: '',
      // inputCompanyError: false,
      // focusCompany: false,
      // Address
      inputAddress: '',
      inputAddressError: false,
      focusAddress: false,
      // Country
      inputCountry: '',
      inputCountryError: false,
      focusCountry: false,
      // Email
      inputEmail: '',
      inputEmailError: false,
      focusEmail: false,
      // Phone
      inputPhone: '',
      inputPhoneError: false,
      focusPhone: false,
      // First & Last Name
      inputName: '',
      inputNameError: false,
      focusName: false,
      // User signature
      signatureData: '',
      signatureDataError: false,
      showError: false,
      errorMessage: '',
      loadQuestionSection: false,
      // Textarea
      textareaTxtDiscover: '',
      textareaTxtDomain: '',
      textareaTxtCollection: '',
      textareaTxtMembers: '',
      isFocusedOnTxtDiscover: true,
      isFocusedOnTxtDomain: false
    }
  },
  mounted () {
    this.$store.commit('updateCursorType', 3)
    // setTimeout(() => this.$store.commit('updateCursorType', 3), 600)
    // this.isOffSignature()
  },
  methods: {
    // Clear the canvas, therefore delete signature
    clearSignature () {
      this.$refs.signaturePad.clearSignature()
      this.signatureDataError = false
      this.showError = false
    },
    // Save the canvas as data:xxx
    saveSignature () {
      this.signatureData = this.$refs.signaturePad.saveSignature()
      setTimeout(() => {
        document.getElementById('bc-discovery').focus()
      }, 100)
    },
    onMemberFormSubmit () {
      // Check the input fields on "Submit"
      // if (!this.inputCompany.length) {
      //   this.errorMessage = 'company'
      //   this.inputCompanyError = true
      //   this.showError = true
      //   return
      // }
      if (!this.inputAddress.length) {
        this.errorMessage = 'address'
        this.inputAddressError = true
        this.showError = true
        return
      }
      if (!this.inputCountry.length) {
        this.errorMessage = 'country'
        this.inputCountryError = true
        this.showError = true
        return
      }
      if (!this.inputEmail.length) {
        this.errorMessage = 'email'
        this.inputEmailError = true
        this.showError = true
        return
      }
      if (!this.inputPhone.length) {
        this.errorMessage = 'phone'
        this.inputPhoneError = true
        this.showError = true
        return
      }
      if (!this.inputName.length) {
        this.errorMessage = 'name'
        this.inputNameError = true
        this.showError = true
        return
      }
      if (this.signatureData.isEmpty) {
        this.errorMessage = 'signature'
        this.signatureDataError = true
        this.showError = true
        return
      } else {
        this.signatureDataError = false
        this.showError = false
      }
      // Form submit if everything is truthy
      if (
        this.inputAddress.length && this.inputCountry.length &&
        this.inputEmail.length && this.inputPhone.length &&
        this.inputName.length && !this.signatureData.isEmpty
      ) {
        // TODO:
        // DISABLED FOR NOW
        // this.$refs.memberForm.submit()
        this.loadQuestionSection = true
      }
    },
    //
    // Input fields on:
    //
    // 1. Blur - focus out
    // isCompanyFocused () {
    //   if (!this.inputCompany.length) {
    //     this.focusCompany = false
    //   } else {
    //     this.focusCompany = true
    //   }
    //   this.inputCompanyError = false
    //   this.showError = false
    // },
    isAddressFocused () {
      if (!this.inputAddress.length) {
        this.focusAddress = false
      } else {
        this.focusAddress = true
      }
      this.inputAddressError = false
      this.showError = false
    },
    isCountryFocused () {
      if (!this.inputCountry.length) {
        this.focusCountry = false
      } else {
        this.focusCountry = true
      }
      this.inputCountryError = false
      this.showError = false
    },
    isEmailFocused () {
      if (!this.inputEmail.length) {
        this.focusEmail = false
      } else {
        this.focusEmail = true
      }
      this.inputEmailError = false
      this.showError = false
    },
    isPhoneFocused () {
      if (!this.inputPhone.length) {
        this.focusPhone = false
      } else {
        this.focusPhone = true
      }
      this.inputPhoneError = false
      this.showError = false
    },
    isNameFocused () {
      if (!this.inputName.length) {
        this.focusName = false
      } else {
        this.focusName = true
      }
      this.inputNameError = false
      this.showError = false
    },
    onBlurTextarea (elemTxt) {
      if (elemTxt === 'bcDiscover') {
        this.isFocusedOnTxtDiscover = false
      } else {
        this.isFocusedOnTxtDomain = false
      }
      if (this.$refs[elemTxt].value) {
        if (elemTxt === 'bcDiscover') {
          this.isFocusedOnTxtDiscover = true
        } else {
          this.isFocusedOnTxtDomain = true
        }
      }
    },
    // 2. Focus
    // focusCompanyField () {
    //   this.focusCompany = true
    // },
    focusAddressField () {
      this.focusAddress = true
    },
    focusCountryField () {
      this.focusCountry = true
    },
    focusEmailField () {
      this.focusEmail = true
    },
    focusPhoneField () {
      this.focusPhone = true
    },
    focusNameField () {
      this.focusName = true
    },
    onFocusTextarea (elemTxt) {
      if (elemTxt === 'bcDiscover') {
        this.isFocusedOnTxtDiscover = true
      } else {
        this.isFocusedOnTxtDomain = true
      }
    },
    // Textarea forms submit function
    submitForm (evt) {
      evt.preventDefault()
      // console.log(this.inputAddress, this.inputCountry, this.inputEmail, this.inputPhone, this.inputName, this.signatureData, this.textareaTxtDiscover, this.textareaTxtDomain)
      axios.post('service/handler.php', {
        // inputCompany: this.inputCompany,
        inputAddress: this.inputAddress,
        inputCountry: this.inputCountry,
        inputEmail: this.inputEmail,
        inputPhone: this.inputPhone,
        inputName: this.inputName,
        signatureData: this.signatureData,
        textareaTxtDiscover: this.textareaTxtDiscover,
        textareaTxtDomain: this.textareaTxtDomain,
        textareaTxtCollection: this.textareaTxtCollection,
        textareaTxtMembers: this.textareaTxtMembers
      }).then((response) => {
        if (response) {
          this.$router.push('thankyou')
        }
      }).catch((e) => {
      })
      // this.$refs.questionsForm.submit()
      this.$router.push('thankyou')
    },
    // Disable the custom mouse cursor when user
    // hovers over the Signature element
    isOnSignature () {
      this.$store.commit('updateCursorType', 0)
    },
    isOffSignature () {
      this.$store.commit('updateCursorType', 3)
    }
  }
}
</script>

<style scoped>
.registration__wrapper__form {
  z-index: 100;
}
</style>>
